export default "__VITE_ASSET__doU6ovWIBPWSMuQwACyWqw__"